import { render, staticRenderFns } from "./MeetingMinutesForm.vue?vue&type=template&id=840873ca&"
import script from "./MeetingMinutesForm.vue?vue&type=script&lang=js&"
export * from "./MeetingMinutesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports